import script from "./area.vue?vue&type=script&lang=js&setup=true"
export * from "./area.vue?vue&type=script&lang=js&setup=true"

import "./area.vue?vue&type=style&index=0&id=0f283726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f283726"]])

export default __exports__